import { combineReducers } from "redux";
import flows from "./flows";
import settings from "./settings";
import users from "./users";
import logs from "./logs";
import roles from "./roles";
import udasSocket from "./udasSocket";
import subscriptions from "./subscriptions";
import credentialManagement from "./credentialManangement";
import customerBilling from "./customerBilling";
import integrations from "./integrations";
import auth from "./auth";
import products from "./products";
import sharing from "./sharing";
import connectors from "./connectors";

const portalReducer = combineReducers({
  flows,
  settings,
  users,
  logs,
  roles,
  udasSocket,
  subscriptions,
  credentialManagement,
  customerBilling,
  integrations,
  auth,
  products,
  sharing,
  connectors,
});

export default portalReducer;
